export const INTENT_FAILED_EVENT = 'intent:failed';

export interface IntentFailedPayload {
  actionId: string;
  reason: string;
}
